import { deleteComment as deleteCommentDiagram} from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type DeleteCommentProps = ApiMethodBase & {
    commentID: string,
};

export const deleteComment = ({ commentID, eventEmitter }: DeleteCommentProps) => {
    deleteCommentDiagram(commentID);
};
